<template>
  <div class="about">
    <div class="top">
      <div class="top_title">留言绘语</div>
      <div>
        <current-path>
          <template slot="sonPath">
            留言板
          </template>
        </current-path>
      </div>
    </div>
    <div style="min-height:300px">
      <p class="liuyan">雁过留声</p>
      <p class="laile"><img src="../../assets/contact/u54.png"/><i>既然来了，就留下你的足迹吧...</i></p>
      <p class="flowers">留言是一束鲜花，为你带来芬芳；留言是一缕阳光，给你送去温暖；留言是我的真诚，送出虔诚祈福；留言是我的心语，道出美好祝愿。</p>
    </div>
  </div>
</template>
<script>
import CurrentPath from '../../components/CurrentPath.vue'
export default {
  components: { CurrentPath },
  data () {
    return {
      currentTab: 1, // 默认公司简介
    }
  },
  methods: {
    changeTab (index) {
      this.currentTab = index
    }
  }
}
</script>
<style lang="stylus" scoped>
.about
  width 1200px
  margin 0 auto
  transform translateY(-40px)
.top
  width 900px
  padding 10px 20px
  background-color #ffffff
  margin 0 auto
  overflow hidden
  display flex
  justify-content space-between
  .top_title
    font-size 18px
    width 100px
    padding-bottom 10px
    border-bottom 1px solid #008000
.about_tab
  display flex
  justify-content flex-start
  margin-top 10px
  border-bottom 1px solid #CCCCCC
  padding-bottom: 20px;
  div
    padding 10px 20px
    font-size 18px
.activeTab
  background-color #E6AC00
  color #ffffff
  position relative
  &::after
    content ''
    display block
    position absolute
    width:0;
    height:0;
    border-width:7px 7px 0;
    border-style:solid;
    border-color:#E6AC00 transparent transparent;/*灰 透明 透明 */
    left 48px
    bottom -7px
.about_content
  margin-top 20px
  font-size 16px
  line-height 32px
  min-height 200px
  .idtent
    text-indent 32px
    text-align center
  img
    display block
    margin 0 auto

.liuyan
  font-size 20px
  font-weight bold
  padding: 20px 0
  border-bottom 1px solid #cccccc
.laile
  font-size 16px
  color #cccccc
  padding 15px 0
  border-bottom 1px solid #cccccc
  font-style italic
  >img
    width 25px
    height 25px
.flowers
  color #cccccc
  padding 15px
</style>
